import { Component,ElementRef, NgZone, OnInit, ViewChild,ViewContainerRef } from '@angular/core';
import { VgAPI } from 'videogular2/core';
import { VgCoreModule } from 'videogular2/core';
import { VgControlsModule } from 'videogular2/controls';
import { VgBufferingModule } from 'videogular2/buffering';
import { StreamingService } from '../../services/streaming.service';
import { Router,ActivatedRoute } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import { Http, Request } from '@angular/http';
import { Upload,FileuploadService } from '../../services/fileupload.service';
import {Observable} from 'rxjs/Rx';
import { AppService } from '../../services/app.service';
import { isArray, isObject } from 'util';
import * as CryptoJS from 'crypto-js';
import { of } from 'rxjs/observable/of';


declare var $: any;
declare var jQuery:any;
declare var indexedDB:any;
declare var screen_index: any;

export interface IMedia {
  title: string;
  src: any;
  type: string;
  thumbnail:string;
  id:string;
  duration:number;
  ad_id:string;
  ad:any;
  cache:boolean;
  secure_src:any;
  media_id:any;
}



@Component({
  selector: 'app-streaming',
  templateUrl: './streaming.component.html',
  styleUrls: ['./streaming.component.css'],
  
})
export class StreamingComponent implements OnInit {

  @ViewChild('videoContainer') videoContainer;

  options = {
    audio: false,
    video: true,
    width:  200,
    height: 200,
    fallbackQuality: 85,
  };

  next_last_time:number = 0;

  InternetConnected: Observable<boolean>;

  divider_media = {
    src:'./assets/videos/billbo_divider_short.mp4',
    type:'divider',
    title:'Billbo.tv',
    id:'billbo.tv',
    thumbnail:'',
    duration:7,
    ad:{layer_on:false,layer_html:'',type:'divider'},
    ad_id:null,
    cache:true,
    secure_src:null,
    media_id:null
  }


  video_intro:boolean = true;
  page_ready:boolean = false;
  dump_queue_option:boolean = true;
  client_position = { latitude:0,longitude:0};
  local_prefix = 'Billbo_';

  border_class:string = 'border1';
  border_class_index:number = 1;
  schedule:any[] = [];
  playlist: any[] = [];
  show_playlist: Array<any> = [];
  resources: Array<any> = [];

  firstload:boolean = true;
  extra_params:string = '';
  iframe_src:string = '';
  screen:any = {
    width:128,
    height:128,
    webcam:false,
    plan:null,
    resolution:null
  };

  
  public webcam//will be populated by ack-webcam [(ref)]
  public base64
  updating_playlist:boolean = false;
  currentIndex = 0;
  currentScheduleIndex = null;
  currentResourceId:string = null;
  webcamRound = 0;
  takeSnapEveryXRound = 3;
  nullCurrentItem = {
    id:null,
    type:'divider',
    duration:1,
    ad:{
      layer_on:false,
      layer_html:'',
      type:null
    },
    ad_id:null,
    src:null,
    cache:false,
    secure_src:null,
    media_id:null
  };
  currentItem = {
    id:null,
    type:'divider',
    duration:1,
    ad:{
      layer_on:false,layer_html:'',type:null
    },
    ad_id:null,
    src:'',
    cache:false,
    secure_src:null,
    media_id:null
   };
  api: VgAPI;
  client_version:string = "0.5.0";
  loadVideo = false;
  idb:any;
  db_name:string = 'billbo_client';
  store_type:string = 'media';
  db:any;
  SESSION_ID:number = null;
  CLIENT_NAME:string = '';
  webcam_on:boolean = false;
  online_on:boolean = false;
  MACHINE_ID:any = '';
  free_mode:boolean = false;
  is_fullScreen:boolean = false;
  account_key:string = '';
  new_version:boolean = false;
  playlist_loaded:boolean = false;
  screen_id:any;
  screen_name:string;
  intervalSendOnline;
  intervalUpdatelist;
  intervalSnapshot;
  intervalUpdateCounts;
  resource_loaded:number=0;
  layer1:boolean = false;
  
  date_obj:any = null;
  panel_info:boolean = true;

  ad_timer:any;
  webcam_timer:any;
  layer_timer:any;

  //isConnected: Observable<boolean>;
  isConnected:boolean = false;
  clock_error:boolean = false;
  
  constructor(
    private streamingService:StreamingService,
    private route: ActivatedRoute,
    
    private sanitizer: DomSanitizer,
    private http:Http,
    private fileup:FileuploadService,
    private appService: AppService,
    private router:Router,
    
    
  ) { 

    
    
    this.date_obj = new Date();

    this.InternetConnected = Observable.merge(
      Observable.of(navigator.onLine),
      Observable.fromEvent(window, 'online').map(() => true),
      Observable.fromEvent(window, 'offline').map(() => false));

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position)=>{
        
        this.client_position = {longitude:position.coords.longitude,latitude:position.coords.latitude};
        
      });
    } 

    
    this.route.params.subscribe(params => {
      
      //this.ad.$key = params['id']; // (+) converts string 'id' to a number
  
      if(typeof(params['id']) != 'undefined'){
        if(!this.appService.isConnected(params['id'])){
        
          console.log("NOT CONNECTED");
          this.screen_id = params['id'];
          this.logoutScreen();
          
        
        }
        
        let connect_data = this.appService.getConnectData(params['id']);
        //this.store_type = 'billbo_cache_'+connect_data.screen_id;
        //console.log(this.store_type);
        
        this.screen_id = connect_data.screen_id;
        
        this.screen_name = connect_data.screen_name;
        this.MACHINE_ID = appService.getMachineId();
        this.CLIENT_NAME = connect_data.client_name;
        this.client_version = appService.getVersionStr();
   /* this.isConnected = new Observable(observer => {
        observer.next(true);
    });


    this.isConnected = Observable.merge(
      Observable.of(navigator.onLine),
      Observable.fromEvent(window, 'online').map(() => true),
      Observable.fromEvent(window, 'offline').map(() => false)
    );*/
    }

  });

   
  }

  ngOnInit() {
   
    if (!('indexedDB' in window)) {
      console.log('This browser doesn\'t support IndexedDB');
      return;
    }

    var request = indexedDB.open(this.db_name, 1);
    
    request.onupgradeneeded = (event) => {
      
    
      //console.log('Performing upgrade');
      this.idb = event.target.result;
      //console.log('Creating object store');
      this.idb.createObjectStore(this.store_type);
    };

    
    request.onsuccess = (event) => {
      //database loaded
      
      this.idb = event.target.result;

      this.loadCache();
      
      
      //this.online_on = this.getLocalStatus('transmiting-'+this.screen_id);
      this.webcam_on = this.getLocalStatus('webcam-'+this.screen_id);
      
      //send online signal
      this.sendOnline(true);
      
      //set interval for online signal
      this.intervalSendOnline = Observable.interval(1000 * 45).subscribe(x => { //30 seg
          this.sendOnline();
      });

      //set interval to process ad stats
      this.intervalUpdateCounts = Observable.interval(1000*60*15).subscribe(x =>{
        
        this.processAdQueue();
        
      });
      
      //set interval to update playlist
      this.intervalUpdatelist = Observable.interval(5000 * 60).subscribe(x => { // cada 5 min
        this.updatePlaylist();
      });

      
      //set interval to take webcam snapshot
      this.intervalSnapshot = Observable.interval(5000 * 60).subscribe(x => {
        if(this.webcam_on && this.isConnected && this.screen.webcam){
          this.takeSnapshot();
        }
      });

    }
   
  }

  keyPress(event){
    if(event.keyCode == 73){
      this.panel_info = !this.panel_info;
    }

    if(event.keyCode == 66){ //b
      this.border_class_index+=1;
      if(this.border_class_index == 3){
        this.border_class_index = 0;
      }
      this.border_class = 'border'+this.border_class_index;
      localStorage.setItem(this.screen_id+'-PlayerBorder',this.border_class);
      
      //ACAAAA
    }
  }
  /*
  load screen cache data
  */
  loadCache(){
    this.playlist = [];
    this.show_playlist = [];
    this.resources = [];

    let border = localStorage.getItem(this.screen_id+'-PlayerBorder');
    if(border != null && border != '' && border != 'null'){
      this.border_class = border;
    }

    //screen
    let json = localStorage.getItem(this.screen_id+'-BillboCurrentScreen');
    
    if(json != '' && json != null && json != 'null'){
      this.page_ready = true;
      this.screen = JSON.parse(json);
      
      if(typeof(this.screen.resolution.height) != 'undefined'){
        
        this.options.height = this.screen.resolution.height;
      
        this.options.width = this.screen.resolution.width;
      }
    }

    //resources
    json = localStorage.getItem(this.screen_id+'-BillboCurrentResources');
    
    if(json != null && json != '' && json && json != 'null'){
      let resources = JSON.parse(json);
      let timenow = new Date().getTime()/1000;
      
      var transaction = this.idb.transaction([this.store_type], "readwrite"); 
      if(isArray(resources)){
        console.log("CACHE: LOADING RESOURCES");
        resources.forEach((res,ind)=>{
          
          if(res.time_end_at < timenow){
            console.log("EXPIRED_AD_DELETE_CACHE");
            resources.splice(ind,1);
            transaction.objectStore(this.store_type).delete(res.media_id);
          }else{
            if(resources[ind].ad.type != 'app'){
              this.getMediaFile(res.src,res.media_id,true);
              resources[ind].cache = false;
            }else{
              resources[ind].secure_src = this.sanitizer.bypassSecurityTrustResourceUrl(res.src);
              resources[ind].cache = true;

            }
            
            
          }
        });
        this.resources = resources;
        this.playlist_loaded = true;
      }
    }

    json = localStorage.getItem(this.screen_id+'-BillboCurrentPlaylist');
    
    if(json != null && json != '' && json && json != 'null'){
      let playlist = JSON.parse(json);
      if(isArray(playlist)){
        console.log("CACHE_PLAYLIST");
        //console.log(playlist);
        this.playlist = playlist;
      }else{
        this.playlist_loaded = false;
      }
    }

    json = localStorage.getItem(this.screen_id+'-BillboCurrentSchedule');
    
    if(json != null && json != '' && json && json != 'null'){
      let schedule = JSON.parse(json);
      if(isObject(schedule)){
        console.log("CACHE_SCHEDULE");
        //console.log(schedule);
        this.schedule = schedule;
      }else{
        console.log("EROR_CACHE_SCHEDULE");
      }
    }

    var date = new Date();
    let dayofweek = date.getDay();
    let hour = date.getHours();
    this.currentScheduleIndex = dayofweek+'-'+hour;
    
    
  }

  processAdQueue(){
    if(this.online_on && this.isConnected){
      this.dump_queue_option = false;
      this.streamingService.processAdCountQueue(this.screen.id);
      setTimeout(()=>{
        this.dump_queue_option = true;
      },15000);
    }

  }

  findResource(media_id){
    let return_index = -1;
    this.resources.forEach((ad,index)=>{
      if(ad.media_id === media_id){
        return_index = index; 
      }
    })
    return return_index;
  }

  isResourceCached(media_id,index = null){
    if(index == null){
      index = this.findResource(media_id);
    }
    if(index !== -1){
      let ad = this.resources[index];
      return (typeof(ad.cache) != 'undefined' && ad.cache == true);
    }else{
      return false;
    }
  }

  updatePlaylist(){
    if(this.isConnected){
      this.updating_playlist = true;
      
      this.streamingService.getStreaming(this.screen.id).subscribe(d=>{
        
        console.log(':RFRSH');
        this.updating_playlist = false;
        if(d.status == 'OK'){
          let res = d.data;
          
          if(typeof(res.ads) != 'undefined'){
            res.ads.forEach((ad)=>{
              let index = this.findResource(ad.media_id);
              if(index == -1){ //no existe media_id
                 
                 if(ad.ad.type == 'app'){ //avoid

                  ad.secure_src = this.sanitizer.bypassSecurityTrustResourceUrl(ad.src);
                  ad.cache = true;
                 }else{
                  ad.cache = false;
                 }
                 
                 this.resources.push(ad);
                 
                 this.getMediaFile(ad.src,ad.media_id); //se procesa el archivo en segundo plano.
                 
              }else{
                //last_update ad for cache manage
              }
            
            });
            
            
            
            this.schedule = res.schedule;
            console.log("NEW SCHEDULE ");
            //console.log(res.schedule);
            //this.playlist = [];

            var date = new Date();
            let dayofweek = date.getDay();
            let hour = date.getHours();

            this.currentScheduleIndex = dayofweek+'-'+hour;

            this.updateSchedulePlaylist(dayofweek,hour);


            this.loadVideo = true; //se usa?
            
            
            
            this.setInitPlaylist();

            this.updateCacheLists();
            
            

            
            //$("#videoContainer").css('height',this.screen.resolution.height);
            //$("#videoContainer").css('width',this.screen.resolution.width);
            
          }else{
            this.playlist_loaded = true;
            this.loadVideo = true;
            this.playlist = [];
            
            this.currentItem = this.divider_media;
            this.currentIndex = 0;
          }
        }  
      });
    }
  }

  updateCacheLists(){
    localStorage.setItem(this.screen.id+'-BillboCurrentResources',JSON.stringify(this.resources));
    localStorage.setItem(this.screen.id+'-BillboCurrentPlaylist',JSON.stringify(this.playlist));
    localStorage.setItem(this.screen.id+'-BillboCurrentSchedule',JSON.stringify(this.schedule));

  }

  setInitPlaylist(){
    this.options.height = this.screen.resolution.height;
      
    this.options.width = this.screen.resolution.width;

      
    if(typeof(this.playlist[this.currentIndex]) == "undefined"){
      this.currentIndex = 0;
    }
    
    /*if(this.playlist.length){
      this.currentResourceId = this.playlist[this.currentIndex];
      let rindex = this.findResource(this.currentResourceId);
      if(rindex != -1){
        this.currentItem = this.resources[rindex];
        if(typeof(this.currentItem.ad.layer_on) != 'undefined' && this.currentItem.ad.layer_on){
          this.layer1=true;
        }
      }else{
        this.currentItem = this.nullCurrentItem;
      }
    }else{
      this.currentItem = this.nullCurrentItem;
    }*/
          
   
    /*if(this.playlist.length){
      //console.log("NOVIDEOCALLNEXT");
      //this.ad_timer = setTimeout(()=>{
        
        this.nextVideo();
        
      //},this.currentItem.duration*1000)
    }*/

    if(this.firstload){
      setTimeout(()=>{
        this.video_intro = false;
        
        this.playlist_loaded = true;
        this.loadVideo = true;

        this.nextVideo();
      },5000);
    }else{
      this.playlist_loaded = true;
      this.loadVideo = true;
    }
    
    this.firstload = false;

    
    
  }
  
  getLocalStatus(key:any){
    let item = localStorage.getItem(this.local_prefix+key);
    if(item == null){
      return false;
    }else{
      return JSON.parse(item);
    }

  }

  setLocalStatus(key:any,value:any){
    localStorage.setItem(this.local_prefix+key,JSON.stringify(value));
  }

  /*
  Send online signal to server
  */
  sendOnline(loadplaylist = false){
    
      var now = new Date().getTime()/1000;
      if(this.playlist.length && this.next_last_time != 0){ //hay anuncios
        
        if(typeof(this.currentItem.duration) != 'undefined'){
          let time_plus = this.next_last_time+this.currentItem.duration+20;
          let delta_time = now - time_plus;
          if(delta_time > 0){
            console.log("BLOCK IN AD");
            console.log(this.currentItem);
            this.nextVideo();
          }
        }
      }
      
    
      this.streamingService.isOnline(this.screen_id,this.currentItem.ad_id,this.online_on,this.webcam_on,this.client_position).subscribe(s=>{
        this.isConnected = true;

        
        if(s.status == 'OK'){
          this.online_on = s.data.online_on;
          if(typeof(s.data.screen_local_time) != 'undefined'){
            let remote_time = parseFloat(s.data.screen_local_time);
            
            let diff = remote_time-now;
            if(diff < -200 || diff > 200){
              console.log("CLOCL ERROR> DIFF:"+(diff));
              this.clock_error = true;
              this.online_on = false;
            }else{
              this.clock_error = false;
            }
          }
          
          this.screen = s.data;
          this.screen.id = this.screen_id;
          
          this.new_version = this.appService.getVersion() < s.v;
          localStorage.setItem(this.screen.id+'-BillboCurrentScreen',JSON.stringify(s.data));
          this.page_ready = true;
          this.free_mode = (this.screen.plan == 'free');
          if(typeof(this.screen.actions) != 'undefined'){
            let time = new Date().getTime()-(80000);
            if(this.webcam_on){
              //console.log(this.screen.actions.takesnap);
              
              if(typeof(this.screen.actions.takesnap) && this.screen.actions.takesnap > time){
                  console.log("REMOTE SNAP");
                  this.takeSnapshot();
                  //this.screenService.unsetAction('takesnap',this.screen.id);
              }

              
            }
            if(typeof(this.screen.actions.update_list) && this.screen.actions.update_list > time){
              console.log("REMOTE UPDATE");
              this.updatePlaylist();
              
            }

            if(typeof(this.screen.actions.webcam) && this.screen.actions.webcam > time){
              console.log("REMOTE WEBCAM");
              this.activateWebcam();
              
            }

            
          }
          if(loadplaylist){
            
            this.updatePlaylist();
          }
        }else{
          if(s.status == 'UNAUTHORIZED'){
            this.logoutScreen(1);
          }
        }
      },(error)=>{
        //hay error
        console.log("NOT CONNECTED:"+error);
        this.isConnected = false;
        if(loadplaylist && this.playlist.length){
          //this.page_ready = true;
          console.log("LOAD OFFLINE PLAY");
          this.setInitPlaylist();
        }
      });
    
      if(!this.playlist.length){
        var date = new Date();
        let dayofweek = date.getDay();
        let hour = date.getHours();

        this.currentScheduleIndex = dayofweek+'-'+hour;

        this.updateSchedulePlaylist(dayofweek,hour);

        if(this.playlist.length){
          
          this.nextVideo();
        }

      }
    
  }

  inPlaylist(media_id){
    return (this.playlist.indexOf(media_id) != -1);
  }

  onPlayerReady(api: VgAPI) {
    this.api = api;
    //this.api.getDefaultMedia().subscriptions.loadedMetadata.subscribe(this.playVideo.bind(this));
    //this.api.getDefaultMedia().subscriptions.ended.subscribe(this.nextVideo.bind(this));
    
  }



  logoutScreen(erase = 0){
    this.intervalSnapshot.unsubscribe();
    this.intervalSendOnline.unsubscribe();
    this.intervalUpdateCounts.unsubscribe();
    this.intervalUpdatelist.unsubscribe();

    clearTimeout(this.ad_timer);
    clearTimeout(this.layer_timer);
    clearTimeout(this.webcam_timer);

    if(screen_index != null){
      screen_index = null;
    }
    if(erase == 1){
      this.appService.removeScreen(this.screen_id);
    }
    this.clearCache((result)=>{
    
      this.appService.exitScreen(this.screen.id);
    });
    
  }

  activateWebcam(){
    this.webcam_on=!this.webcam_on;
    if(this.webcam_on){
      this.webcam_timer = setTimeout(()=>{
        this.takeSnapshot();
      },10000);
      this.setLocalStatus('webcam-'+this.screen.id,true);
    }else{
      this.setLocalStatus('webcam-'+this.screen.id,false);
    }
  }

  updateSchedulePlaylist(dayofweek,hour){
    this.playlist = [];
    let time_now = new Date().getTime()/1000;
    if(typeof(this.schedule[dayofweek]) != "undefined"){
      if(typeof(this.schedule[dayofweek][hour]) != "undefined"){
        let playlist_aux = this.schedule[dayofweek][hour];
        playlist_aux.forEach(media_id=>{
          let index = this.findResource(media_id);
          if(index != -1){
            let item = this.resources[index];
            if(item.ad.time_end_at > time_now && item.ad.time_start_at < time_now){ //time expire control
              this.playlist.push(media_id);
            }
          }
        });
        
      }
    }
  }

  validateCurrent(current,time_now = null){
    if(time_now == null){
      time_now = new Date().getTime()/1000;
    }
   
    if(current.ad_id != null){
      if(current.cache = true){
        
        if(current.ad.time_end_at > time_now && current.ad.time_start_at < time_now){
          
          return true;
        }else{
          //console.log("AD TIME INVALID:"+current.ad.name+"TE:"+current.ad.time_end_at+" TS:"+current.ad.time_start_at+" TN:"+time_now);
          
        }
      }else{
        //console.log("AD NOT IN CACHE:"+current.ad.name);
      } 
    }else{
      //console.log("NULL");
    }
    return false;
    
  }

  nextVideo() {
    let the_date = new Date();
    let time_now = the_date.getTime()/1000;
    let dayofweek = the_date.getDay();
    let hour = the_date.getHours();

    clearTimeout(this.ad_timer);
    clearTimeout(this.layer_timer);
    
    this.currentIndex++;

    if(this.currentScheduleIndex !== dayofweek+'-'+hour){
      this.currentScheduleIndex = dayofweek+'-'+hour;
      this.updateSchedulePlaylist(dayofweek,hour);
      this.currentIndex = 0;
    }

    //console.log(":NV:"+(time_now-this.next_last_time)+' // LT:'+this.next_last_time+' // NOW:'+time_now);
    
    
    this.next_last_time = time_now;
    

    if (this.currentIndex === this.playlist.length) {
        this.currentIndex = 0;
        
    }
    

    //aca tengo que ir a buscar en la db e
    if(typeof(this.playlist[this.currentIndex]) != 'undefined'){
      let rindex = this.findResource(this.playlist[this.currentIndex]);
      if(rindex != -1){
        let current = this.resources[rindex];
        
      
        //la pantalla esta activa y cargo reproducción en anuncio
        
        if(this.validateCurrent(current,time_now) && typeof(this.idb.transaction) != 'undefined' ){

          if(current.ad.type == 'app'){
            if(typeof(current.ad.req_internet) == 'undefined'){
              current.ad.req_internet = true;
            }
            
            
            if(current.ad.req_internet && this.isConnected){
                let special_url = current.src
                if(!this.online_on){
                  special_url+='&test_mode=1';
                }
                current.src = special_url;
                
                this.http.head(current.src).subscribe((resp)=>{
                  this.layer1 = false;
                  
                  if(current.ad.layer_on){
                    
                      this.layer_timer = setTimeout(()=>{
                        
                        this.layer1 = true;
                      },current.ad.layer_show_up);
                    
                    if(current.ad.layer_show_out > current.ad.layer_show_up){
                      
                      this.layer_timer = setTimeout(()=>{
                          
                          this.layer1 = false;
                        },current.ad.layer_show_out)
                      
                    }
                  }
                  if(current.ad.type != 'divider'){
                    this.registerView(current);
                  }  
                  this.currentItem = current;
                  
                  this.ad_timer = setTimeout(()=>{
                    //this.playVideo();
                    this.nextVideo();
                  
                  },current.duration*1000);
                  
                },(err)=>{
                  console.log('SRC:FAIL:PASS');
                  this.nextVideo();
                  
                });
            
            }else{
              if(current.ad.req_internet == false){
                if(current.ad.layer_on){
                      
                  this.layer_timer = setTimeout(()=>{
                      
                      this.layer1 = true;
                    },current.ad.layer_show_up);
                  
                  if(current.ad.layer_show_out > current.ad.layer_show_up){
                    
                    this.layer_timer = setTimeout(()=>{
                        
                        this.layer1 = false;
                      },current.ad.layer_show_out)
                    
                  }
                }
                this.registerView(current);
                
                
                this.currentItem = current;
                this.ad_timer = setTimeout(()=>{
                  //this.playVideo();
                  this.nextVideo();
                },current.duration*1000);
              }else{
                console.log("NOCONNECT_NXT_VD");
                this.nextVideo();    
              }
            }

          }else{
            if(current.ad.type != 'divider'){
              this.registerView(current);
            }  

            var transaction = this.idb.transaction([this.store_type], "readwrite"); 
            
            transaction.objectStore(this.store_type).get(current.media_id).onsuccess = (event)=> {
              
              if(typeof(event.target.result) != "undefined"){
                //console.log(":VIAD");
                //var binary_encoded = event.target.result;
                //var URL = window.URL;
                //var videoURL = URL.createObjectURL(binary_encoded);
                //current.src = this.sanitizer.bypassSecurityTrustResourceUrl(videoURL);
                
                this.currentItem = current;
                this.layer1 = false;
                if(current.ad.layer_on && typeof(current.ad.layer_html) != 'undefined'){
                  // console.log(":SHUP:"+current.ad.layer_show_up+":"+current.ad.id);
                  this.layer_timer = setTimeout(()=>{
                      //console.log(":IN:"+current.ad.id);
                      this.layer1 = true;
                    },current.ad.layer_show_up)
                  
                  if(current.ad.layer_show_out > current.ad.layer_show_up){
                      //console.log(":SHOT:"+current.ad.layer_show_out+":"+current.ad.id);
                      this.layer_timer = setTimeout(()=>{
                        //console.log(":OUT:"+current.ad.id);
                        this.layer1 = false;
                      },current.ad.layer_show_out)
                    
                  }
                }
                //console.log("TYPE:"+current.ad.type);
                if(current.ad.type == 'video'){
                  this.playVideo();
                    
                }
                
                this.ad_timer = setTimeout(()=>{
                    
                  this.nextVideo();
                },current.duration*1000)
              


              }else{
                console.log("ERROR VIDEO");
                this.nextVideo();
              }
          
            };
          }
        }else{
          //invalid ad or not in cache
          /*if(current.type == 'image'){
            
            this.registerView(current);
            
            
            //console.log("img "+current.duration*1000);
            setTimeout(()=>{
              //console.log("voy al siguiente video");
              this.nextVideo();
            },current.duration*1000);
          }
          this.currentItem = current;
          */
         console.log("INVALID OR NOT CACHE");
         this.nextVideo();
         /*setTimeout(()=>{
            console.log("INVALID OR NOT CACHE");
            
          },current.duration*1000);*/
        }
      }else{ //rindex not found
        console.log("INDEX NOT FOUND");
        //this.nextVideo();
      }
    }else{
      console.log("CURRENT INDEX ERROR:"+this.currentIndex);
    }
 
  }

  pauseVideo(){
    //this.api.pause();
  }

  playVideo() {
    if(this.currentItem != null && this.currentItem.ad.type == 'video'){
      this.api.play();
    }
  }

  onClickPlaylistItem(item,index) {
    if(!this.inPlaylist(item.media_id)){
      return false;
    }
    let plindex = -1;
    this.playlist.forEach((ad,ind)=>{
      if(ad == item.media_id){
        plindex = ind;
      }
    });
    if(plindex > -1){
      if(plindex > 0){
        this.currentIndex = plindex-1;
      }else{
        this.currentIndex = this.playlist.length;
      }
      
      this.nextVideo();
    }
  }

  getVideoLoadingTag() {
   /* return this.sanitizer.bypassSecurityTrustHtml(
      `<video width="`+this.options.width+`" height="`+this.options.height+`" autoplay muted>
          <source src="${this.divider_media.src}" type="video/mp4">No HTML5 supported.</source>
       </video>`
    );*/
  }

  
  registerView(current){
    if(this.online_on){
      
      this.streamingService.countAdView(current.ad.account_id,current.ad_id,this.screen.id,this.screen_name,this.client_position.latitude,this.client_position.longitude,current.title,current.src,current.duration);
      if(current.ad.audit == true){
        setTimeout(()=>{
          
          this.takeAuditSnapshot(current);
        },(current.duration/2.5)*1000); //saco la pic en medio del anuncio
        
      }
    }
    
    
  }

  getMediaFile(url,key,cache = false){
    
    if(url == 'undefined' || typeof(url) == 'undefined'){
      return false;
    }
   
    
    let transaction = this.idb.transaction([this.store_type], "readwrite"); 
    
    transaction.objectStore(this.store_type).get(key).onsuccess = (event)=> {
      
      
      if(typeof(event.target.result) != "undefined"){
        
        this.playlist_loaded = true;
        //this.resource_loaded-=1;
        //console.log(key+" FROM CACHE");
        this.updatePlaylistItem(key,event.target.result);
      }else{
        if(this.isConnected && !cache){
          var xhr = new XMLHttpRequest(),
          binary_data;
          xhr.open("GET", url, true);
          xhr.responseType = "blob";
          xhr.addEventListener("load", ()=> {

              if (xhr.status === 200) {
                  binary_data = xhr.response;
                  //console.log(binary_data);
                  //var videoURL = URL.createObjectURL(binary_data);
                  //window.open(videoURL);
                  let transaction = this.idb.transaction([this.store_type], "readwrite"); 
                  transaction.objectStore(this.store_type).put(binary_data, key);  

                  this.updatePlaylistItem(key,binary_data);

              }
              this.playlist_loaded = true;
              //this.resource_loaded-=1;
          }, false);
          xhr.send();
        }
      }
      
    }    
  }


  updatePlaylistItem(media_id,binary_data){
    let rindex = this.findResource(media_id);
    if(rindex != -1){
      var URL = window.URL;
      var videoURL = URL.createObjectURL(binary_data);
      this.resources[rindex].cache_url = videoURL;
      this.resources[rindex].secure_src = this.sanitizer.bypassSecurityTrustResourceUrl(videoURL);
      this.resources[rindex].cache = true;
      
      this.updateCacheLists();

    }
  }

  clearCache(fn){
    var transaction = this.idb.transaction([this.store_type], "readwrite"); 
    var objectStore = transaction.objectStore(this.store_type);

    localStorage.setItem(this.screen.id+'-BillboCurrentSchedule','');
    localStorage.setItem(this.screen.id+'-BillboCurrentPlaylist','');
    localStorage.setItem(this.screen.id+'-BillboCurrentResources','');
    
    this.streamingService.cleanAdCountQueue(this.screen.id);
    var objectStoreRequest = objectStore.clear();
    objectStoreRequest.onsuccess = function(event) {
      // report the success of our request
      /*console.log("WIPE CACHE SUCCESS");
      if(reload){
        this.router.navigate(['streaming']);
      }*/
      fn(true);
      
    };
  }

  takeSnapshot(save = false){
    if(!this.screen.webcam || !this.isConnected){
      return false;
    }
    
    this.webcam.getBase64("image/jpeg")
    .then( (base)=>{
      
      //this.base64=base;
      //console.log('/screen/'+this.screen.$key);
      this.fileup.setPrivatePath(this.screen.account_id+'/screen/'+this.screen.id);
     
      this.fileup.pushUpload(base,'screenshot.jpg');

    })
    .catch( e=>console.error(e) )
    
  }

  takeAuditSnapshot(current){
    if(!this.screen.webcam || !this.isConnected){
      return false;
    }

    if(!this.streamingService.checkAuditable(this.screen.id,current)){
      return false;
    }
    
    this.webcam.getBase64("image/jpeg")
    .then( (base)=>{
      
      //this.base64=base;
      //console.log('/screen/'+this.screen.$key);
      var d = new Date();
      this.fileup.setPrivatePath('screen_audit/'+this.screen.id+'-'+current.ad.id+'/'+d.getTime()+'-snapshot.jpg');
      this.fileup.pushUpload(base,'snapshot.jpg',current.ad);

    })
    .catch( e=>console.error(e) )
  }
 
  //get HTML5 FormData object and pretend to post to server
  genPostData(){
    this.webcam.captureAsFormData({file:'screenshot.jpg'})
    .then( (formData)=>{
      
      this.postFormData(formData);
      
    } )
    .catch( e=>console.error(e) )
  }
 
  //a pretend process that would post the webcam photo taken
  postFormData(formData){
    

    this.fileup.setPrivatePath(this.account_key+'/screenshot/'+this.screen.id);
    //this.fileup.pushUpload(formData);

  }
  
 
  onCamError(err){}
 
  onCamSuccess(){}

}



// WEBPACK FOOTER //
// /Users/andrescufari/Angular/billbo-desktop-v2/src/app/components/streaming/streaming.component.ts